const LS_ANON_ID = 'ctc_anon_id';
const SS_SESSION_ID = 'ctc_session_id';

const EDGE_FUNCTIONS_BASE = 'https://asbctbwxfoosmfehewwl.supabase.co/functions/v1';
const TRACK_EVENT_URL = `${EDGE_FUNCTIONS_BASE}/public-track-event`;

export function getAnonId(): string {
  let id = localStorage.getItem(LS_ANON_ID);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(LS_ANON_ID, id);
  }
  return id;
}

export function getSessionId(): string {
  let id = sessionStorage.getItem(SS_SESSION_ID);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SS_SESSION_ID, id);
  }
  return id;
}

function getUtmParam(params: URLSearchParams, key: string): string | null {
  return params.get(key) || null;
}

export function pageView(): void {
  try {
    const params = new URLSearchParams(window.location.search);

    const payload = {
      anon_id: getAnonId(),
      session_id: getSessionId(),
      event_type: 'page_view' as const,
      page_url: window.location.href,
      page_path: window.location.pathname,
      page_title: document.title,
      referrer: document.referrer || null,
      utm_source: getUtmParam(params, 'utm_source'),
      utm_medium: getUtmParam(params, 'utm_medium'),
      utm_campaign: getUtmParam(params, 'utm_campaign'),
      utm_term: getUtmParam(params, 'utm_term'),
      utm_content: getUtmParam(params, 'utm_content'),
      viewed_at: new Date().toISOString(),
    };

    const body = JSON.stringify(payload);

    fetch(TRACK_EVENT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
      credentials: 'omit',
    }).catch(() => {});
  } catch {
    // Never throw to caller
  }
}
